import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Stepper from "../../../component/common/Stepper";
import SetupInterview from "./SetupInterview";
import UploadJd from "./UploadJd";
import UploadResumes from "./UploadResumes";

type UploadJdLayoutProps = { setLoading: Function };

const UploadJdLayout = ({ setLoading }: UploadJdLayoutProps) => {
  const { state } = useLocation();
  const [jdId, setJDId] = useState(
    state?.postId || localStorage.getItem("createPostId"),
  );
  const [selectedPage, setSelectedPage] = useState(0);
  const [resumes, setResumes] = useState([] as any);
  const [fromPage, setFromPage] = useState("jd");
  const [roundData, setRoundData] = useState({} as any);
  const [currentStep, setCurrentStep] = useState(0);
  const steps = ["Create JD", "Setup Interview", "Upload Candidate"];

  useEffect(() => {
    if (state?.postId) {
      localStorage.setItem("createPostId", state?.postId);
      setJDId(state.postId);
    }
    setLoading(true);
    setLoading(false);
  }, [state?.postId]);

  const loadingOpen = (open: boolean): void => setLoading(open);
  const setPostId = () => {
    setFromPage("jd");
    var pId = localStorage.getItem("createPostId");
    setJDId(pId!);
    setSelectedPage(1);
    setCurrentStep(1);
  };
  const setLevel = (data: any) => {
    setRoundData(data);
    var pId = localStorage.getItem("createPostId");
    setJDId(pId!);
    setSelectedPage(2);
    setCurrentStep(2);
  };
  const setBackUploadJd = () => {
    var pId = localStorage.getItem("createPostId");
    setJDId(pId!);
    setSelectedPage(0);
    setCurrentStep(0);
  };
  const setBackJdRound = (resumeList: any) => {
    setFromPage("resume");
    var pId = localStorage.getItem("createPostId");
    setJDId(pId!);
    setResumes(resumeList);
    setSelectedPage(1);
    setCurrentStep(1);
  };
  return (
    <div className="flex flex-col items-center justify-center overflow-y-auto h-[calc(100vh-90px)] 2xl:h-[calc(100vh-120px)]">
      <Stepper steps={steps} currentStep={currentStep} />
      <div className=" w-[90%]  mt-5 overflow-y-auto">
        {selectedPage === 0 && (
          <UploadJd
            setLoading={loadingOpen}
            postId={jdId}
            setPostId={setPostId}
          />
        )}
        {selectedPage === 1 && (
          <SetupInterview
            setLoading={loadingOpen}
            setLevel={setLevel}
            setBackUploadJd={setBackUploadJd}
            fromPage={fromPage}
          />
        )}
        {selectedPage === 2 && (
          <UploadResumes
            setLoading={loadingOpen}
            setBackJdRound={setBackJdRound}
            resumeList={resumes}
            roundData={roundData}
          />
        )}
      </div>
    </div>
  );
};
export default UploadJdLayout;
